import SkuCarFitment from "./SkuCarFitment/SkuCarFitment";
import classes from "./SkuCarsFitment.module.css";

const SkuCarsFitment = (props) => {
  const { carsFitment } = props;

  return (
    <section className={classes["sku-cars-fitment"]}>
      <h2 className={classes["sku-cars-fitment__header"]}>
        هذه القطعة تتلائم مع
      </h2>
      <ul className={classes["sku-cars-fitment__list"]}>
        {carsFitment.map((brand, index) => (
          <SkuCarFitment
            key={index}
            brandName={brand.brandName}
            brandImage={brand.brandImage}
            models={brand.models}
          />
        ))}
      </ul>
    </section>
  );
};

export default SkuCarsFitment;
